import { Inject, Injectable } from '@angular/core';
import { AppState, AuthService, LogoutOptions, RedirectLoginOptions } from '@auth0/auth0-angular';
import { map, Observable } from 'rxjs';
import { AuthenticationConfig } from '../../security/model/authentication-config';
import { LoginData } from '../../security/model/login-data';
import { UserInfo } from '../../security/model/user-info';
import { SECURITY_MODULE_CONFIG, SecurityModuleConfig } from '../../security/security-config';
import { AuthenticationService } from '../../security/services/authentication-service';


@Injectable()
export class LoginAuth0Service extends AuthenticationService {

  private _authenticationConfig: AuthenticationConfig | undefined = undefined;

  constructor(
    @Inject(SECURITY_MODULE_CONFIG) private config: SecurityModuleConfig,
    private auth: AuthService) {
    super();
    this.authenticationConfig = {
      logoutRedirectUri: this.config.logoutRedirectUri
    };
  }

  public get authenticationConfig(): AuthenticationConfig | undefined {
    return this._authenticationConfig;
  }

  public set authenticationConfig(value: AuthenticationConfig | undefined) {
    this._authenticationConfig = value;
  }

  public login(data: LoginData): Observable<UserInfo> {
    const options: RedirectLoginOptions<AppState> = {
      appState: { target: '/security/bridge' },

      authorizationParams: {
        // redirect_uri: window.location.origin + '/#/security/bridge',
        ui_locales: 'es-ES',
      }
    }
    return this.auth.loginWithRedirect(options).pipe(map(() => {
      return null as unknown as UserInfo;
    }));
  }

  public logout(): Observable<void> {
    if (this._authenticationConfig && this._authenticationConfig.logoutRedirectUri) {
      const options: LogoutOptions = {
        logoutParams: {
          returnTo: this._authenticationConfig.logoutRedirectUri
        }
      };
      return this.auth.logout(options);
    } else {
      return this.auth.logout();
    }
  }

  public isAuthenticated(): Observable<boolean> {
    return this.auth.isAuthenticated$;
  }


}
